<template>
  <div
    class="flex flex-col flex-1 min-w-0 mr-6"
    style="min-width: 263px; height: 248px"
  >
    <div>
      <div class="flex space-x-4">
        <div
          class="bar-item-btn font-bold"
          :class="{
            'bar-item-btn__active': state.timeType == i,
          }"
          v-for="(item, i) in ['1Y', 'ALL']"
          :key="i"
          @click="state.timeType = i"
          style="min-width: auto; font-size: 12px"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="flex-1 min-h-0">
      <VChart class="chart" :option="option"></VChart>
    </div>
  </div>
</template>
<script setup>
import { queryOvDaoInterData } from '@/api/dao';
import SortTag from '@/components/SortTag.vue';
import { chartColor } from '@/constants';
import { useReqByBool } from '@/hooks';
import { BarChart } from 'echarts/charts';
import {
  GraphicComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { computed, inject, onMounted, reactive } from 'vue';
import VChart from 'vue-echarts';

const daoPageInfo = inject('daoPageInfo');

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  GraphicComponent,
]);

const state = reactive({
  timeType: 0,
  list: [],
});
const props = defineProps({
  list: Array,
  option: Object,
});
const showList = computed(() => {
  return state.timeType == 0
    ? state.list.slice(state.list.length - 12, state.list.length)
    : state.list;
});

const option = computed(() => {
  const originList = showList.value;

  const datas = originList.map((x) => x.month);

  const data = [];
  Array(4)
    .fill(0)
    .forEach((_, i) => {
      const arr = [];
      originList.forEach((x) => {
        const y = x.info[i];
        arr.push({
          name: y ? y.plat : '',
          value: y ? y.count : 0,
          label: {
            show: false,
          },
          itemStyle: {
            color: chartColor[i],
          },
        });
      });

      data.push(arr);
    });

  const series = data.map((x) => {
    return {
      type: 'bar',
      stack: 'total',
      label: {
        show: true,
        color: '#fff',
      },
      // emphasis: {
      // focus: 'series',
      // },
      color: chartColor,
      data: x,
    };
  });

  return {
    tooltip: {
      borderColor: '#FFFFFF66',
      backgroundColor: '#1e1f21bb',
      textStyle: {
        color: '#fff',
      },
      formatter: (params) => {
        const { dataIndex } = params;
        const filterData = originList[dataIndex].info;
        const str = `<div class="text-xs"><div>${
          originList[dataIndex].month
        }</div>

        ${`<div class='flex justify-between items-center w-full'>
                      <div class="flex items-center">
                        <span class="mr-4 font-bold">Total</span>
                      </div>
                      <div>${originList[dataIndex].totalSum}</div>
                    </div>`}

        
        ${filterData
          .map((value, i) => {
            return `<div class='flex justify-between items-center w-full'>
                      <div class="flex items-center">
                        <div class="w-2 h-2 rounded-full mr-2" style='background-color:${chartColor[i]}'></div>
                        <span class="mr-4 font-bold">${value.plat}</span>
                      </div>
                      <div>${value.count}</div>
                    </div>`;
          })
          .join('')}</div>`;
        return str;
      },
    },
    grid: {
      left: '0',
      right: '0',
      bottom: '0',
      top: '16%',
      containLabel: true,
    },
    yAxis: {
      type: 'value',
      splitLine: {
        lineStyle: {
          color: '#FFFFFF1A',
        },
      },
    },
    xAxis: {
      type: 'category',
      data: datas,
    },
    series,
  };
});
const { loadData, loading } = useReqByBool(async () => {
  try {
    const res = await queryOvDaoInterData(daoPageInfo.vueState.info.id);
    state.list = res;
  } catch (error) {
    console.log(error);
  }
});

onMounted(() => {
  loadData();
});
</script>
<style></style>
